var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":_vm.info_title}}),_c('v-runtime-template',{attrs:{"template":_vm.info_content}}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }